module.exports = __webpack_public_path__ + "static/media/comparisonBu.a0f7f1ed.svg";